// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b8582c9a","703":"bd548294","787":"d66a4229"}[chunkId] + ".chunk.js";
};